// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__21kQf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__37_0r"};